import type { SVGProps } from 'react';

export const TimeSeriesIcon = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2 2V14H14" stroke={fill ?? '#0071CD'} strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M12.666 6L9.33268 9.33333L6.66602 6.66667L4.66602 8.66667"
      stroke={fill ?? '#0071CD'}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default TimeSeriesIcon;
